import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY } from '@/swagger/constants/surveys-keys';
import { API_POST_SURVEYS_CAMPAIGNS_CALL, KEY_POST_SURVEYS_CAMPAIGNS } from '../constats';
import { MOCK_RESPONSE_POST_SURVEYS_CAMPAIGNS } from '../mocks';

type RequestPostSurveysCampaigns = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY
>['request']['body'];

type ResponsePostSurveysCampaigns = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY
>['response']['body'];

type CallParamsPostSurveysCampaigns = RequestPostSurveysCampaigns & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostSurveysCampaigns = ResponsePostSurveysCampaigns;

type CallErrorPostSurveysCampaigns = GenericApiError;

type CallSelectorsPostSurveysCampaigns = unknown;

export const postSurveysCampaignsCall = createGeneralCall<
  CallParamsPostSurveysCampaigns,
  CallResponsePostSurveysCampaigns,
  CallErrorPostSurveysCampaigns,
  CallSelectorsPostSurveysCampaigns
>({
  id: KEY_POST_SURVEYS_CAMPAIGNS,
  method: 'post',
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_SURVEYS_CAMPAIGNS_CALL(org);
  },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_POST_SURVEYS_CAMPAIGNS
    : undefined,
});
